export const filterConfigText = (value) => {
  if (
    Object.keys(configTranslations).filter((item) => item == value).length == 0
  ) {
    return {};
  }

  return {
    text: `${headerTypes[configTranslations[value].type]} ${
      configTranslations[value].isButton ? "Botão" : ""
    }
    ${configTranslations[value].name}`,
    description: configTranslations[value].description,
  };
};

const configTranslations = {
  acompanhamentos: {
    name: "Acompanhamentos",
    type: "cidade",
    description: [`Visualiza a aba 'Acompanhamentos' dentro do município`],
  },
  adicionarCategoriaTerritorio: {
    name: "Adicionar categoria",
    type: "territorios",
    description: [
      `Libera a possibilidade de adicionar uma nova categoria de território`,
    ],
  },
  adicionarIniciativaTerritorio: {
    name: "Adicionar Iniciativa Território",
    type: "territorios",
    description: [
      `Libera a possibilidade de adicionar iniciativas em um território`,
    ],
  },
  adicionarTerritorio: {
    name: "Adicionar Território",
    type: "territorios",
    description: [`Libera a possibilidade de adicionar um território`],
  },
  agenteTerritorial: {
    isButton: true,
    name: "Agente Territorial",
    type: "cidade",
    description: [`Visualiza o botão 'AGENTE TERRITORIAL' dentro do município`],
  },
  analisarAprovadas: {
    isButton: true,
    name: "Analisar Aprovadas",
    type: "evidencia",
    description: [
      `Pode aprovar evidências dentro da aba 'Evidências -> Evidenciadas' no município`,
    ],
  },
  analisarEvidenciadas: {
    isButton: true,
    name: "Analisar Evidenciadas",
    type: "evidencia",
    description: [
      `Pode finalizar evidências do selo dentro da aba 'Evidências' no município`,
    ],
  },
  analisarRejeitadas: {
    isButton: true,
    name: "Analisar Rejeitadas",
    type: "evidencia",
    description: [
      `Pode rejeitar evidências dentro da aba 'Evidências' no município`,
    ],
  },
  analisarRelatorios: {
    name: "Analisar Relatorios",
    type: "menu",
    description: [
      `Libera visualização do menu (meus relatórios/analisar relatórios), porém cada um possui sua permissão separadamente`,
    ],
  },
  analisarRelatoriosAdministrativos: {
    name: "Analisar Relatorios Administrativos",
    type: "menu",
    description: [
      `Libera visualização do menu (Analisar Relatórios Administrativos/Meus Relatórios Administrativos)`,
    ],
  },
  andamento: {
    name: "Andamento",
    type: "cidade",
    description: [`Libera visualização da aba 'Andamento' dentro do município`],
  },
  cadastroEmLote: {
    isButton: true,
    name: "Cadastro em Lote",
    type: "cidade",
    description: [
      `Libera o botão 'Cadastrar em lote' dentro do filtro na listagem de município`,
    ],
  },
  calendario: {
    name: "Calendário",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Calendário' dentro do município`,
    ],
  },
  carregaMembrosGrupos: {
    name: "Carregar combo de membros automática",
    type: "calendario",
    description: [`Carregar combo de membros automática`],
  },
  configuracao: {
    name: "Configuração",
    type: "menu",
    description: [`Libera a visualização do menu 'Configuração'`],
  },
  perguntas: {
    name: "Perguntas",
    type: "menu",
    description: [`Libera a visualização do menu 'Perguntas'`],
  },
  dashboardAdministrativo: {
    name: "Dashboard Administrativo",
    type: "menu",
    description: [`Libera a visualização do menu 'Dashboard'`],
  },
  desabilitarUsuario: {
    isButton: true,
    name: "Desabilitar e habilitar usuário",
    type: "usuario",
    description: [
      `Libera a visualização do botão 'Bloquear Usuário/Desbloquear Usuário' do menu usuários`,
    ],
  },
  diagnosticoSelo: {
    name: "Diagnostico do Selo",
    type: "cidade",
    isButton: true,
    description: [
      `Libera a possibilidade de visualizar o mini dash de evidências e possibilidade de visualizar a fase do diagnóstico do selo`,
    ],
  },
  downloadDiagnostico: {
    name: "Diagnóstico Selo  --> Download PDF",
    type: "cidade",
    description: [
      `Libera a possibilidade de visualizar o botão 'Download Diagnóstico' do diagnóstico do selo`,
    ],
  },
  editarCategoriaTerritorio: {
    name: "Editar categoria",
    type: "territorios",
    description: [
      `Libera a possibilidade de editar uma categoria de território`,
    ],
  },
  editarIniciativaTerritorio: {
    name: "Editar Iniciativa Território",
    type: "territorios",
    description: [
      `Libera a possibilidade de editar iniciativas em um território`,
    ],
  },
  editarMunicipio: {
    isButton: true,
    name: "Editar Município",
    type: "cidade",
    description: [`Libera o botão 'Editar Município' dentro do município`],
  },
  editarMunicipioVerAD: {
    name: "Editar Município --> Visualizar campo Agente de desenvolvimento (AD)",
    type: "cidade",
    description: [
      `Visualizar campo Agente de desenvolvimento (AD) na edição do município`,
    ],
  },
  editarMunicipioVerAtividadeEconomica: {
    name: "Editar Município --> Visualizar Bloco de Atividades Econômicas",
    type: "cidade",
    description: [`Visualizar Atividades Econômicas na edição do município`],
  },
  editarMunicipioVerDadosSocioeconomicos: {
    name: "Editar Município --> Visualizar Bloco de Dados Socioeconômicos",
    type: "cidade",
    description: [
      `Libera os campos abaixo da edição do município:`,
      `População`,
      `Orçamento`,
      `IDH`,
      `PIB`,
      `Densidade Demográfica`,
      `Renda média da população`,
      `Receita`,
      `Despesa`,
      `Número de Empresas`,
      `ME e EPP(N°)`,
      `MEI (N°)`,
      `Mei/Total (%)`,
      `IGM`,
      `Link Google Maps`,
      `Número do Contrato`,
    ],
  },
  editarMunicipioVerEixos: {
    name: "Editar Município --> Visualizar campo Eixo",
    type: "cidade",
    description: [`Visualizar campo Eixo na edição do município`],
  },
  editarMunicipioVerPrefeito: {
    name: "Editar Município --> Visualizar Bloco de edição de Prefeito ",
    type: "cidade",
    description: [
      `Libera os campos abaixo da edição do município:`,
      `Prefeito`,
      `Partido`,
    ],
  },
  editarTerritorio: {
    name: "Editar Território",
    type: "territorios",
    description: [`Libera a possibilidade de editar um território`],
  },
  editarTipoSolucao: {
    name: "Tipo de Solução",
    type: "menu",
    description: [`Libera o menu 'Tipo de Solução'`],
  },
  editaHorasUtilizadas: {
    name: "Editar horas utilizadas",
    type: "relatorio",
    description: [
      `Libera a edição do campo 'Horas Utilizadas' no cadastro/edição na aba 'Relatório' do município`,
    ],
  },
  editaHorasUtilizadasQuandoTarefasSemHrPredefinidas: {
    name: "Editar horas utilizadas APENAS quando não existir tarefas com horas pré-definidas",
    type: "relatorio",
    description: [
      `Libera a edição do campo 'Horas Utilizadas' no cadastro/edição na aba 'Relatório' do município, quando as tarefas não possuem horas predefinidas`,
    ],
  },
  eixos: {
    name: "Eixos",
    type: "menu",
    description: [`Libera a visualização do menu 'Eixos'`],
  },
  encontros: {
    name: "Encontros",
    type: "menu",
    description: [`Libera a visualização do menu 'Agendas/Encontros'`],
  },
  enviarAprovadas: {
    isButton: true,
    name: "Enviar Aprovadas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de aprovadas em evidências que não seja selo`,
    ],
  },
  enviarEvidenciadas: {
    isButton: true,
    name: "Enviar Evidenciadas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de evidenciadas em evidências que não seja selo`,
    ],
  },
  enviarRejeitadas: {
    isButton: true,
    name: "Enviar Rejeitadas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de rejeitadas em evidências`,
      `Libera os botões 'Salvar e enviar' no selo`,
    ],
  },
  enviarRespondidas: {
    isButton: true,
    name: "Enviar Respondidas",
    type: "evidencia",
    description: [
      `Libera a possibilidade de enviar arquivos na aba de respondidas em evidências`,
      `Libera os botões 'Salvar e enviar' no selo`,
    ],
  },
  eventos: {
    name: "Eventos",
    type: "menu",
    description: [`Libera a visualização do menu 'Eventos'`],
  },
  evidencias: {
    name: "Evidências",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Evidências' dentro do município`,
    ],
  },
  recursos: {
    name: "Recursos",
    type: "cidade",
    description: [
      `Libera a visualização do menu 'Recursos' dentro do município`,
    ],
  },
  criarRecursos: {
    name: "Criar recursos",
    type: "cidade",
    description: [
      `Habilita o botão 'Novo recurso' para criação de recursos no município`,
    ],
  },
  analisarRecursos: {
    name: "Analisar Recursos",
    type: "cidade",
    description: [
      `Permite analisar, decidir e comentar recursos enviados pelas salas`,
    ],
  },
  excluirTerritorio: {
    name: "Excluir Território",
    type: "territorios",
    description: [`Libera a possibilidade de excluir um território`],
  },
  exibeComunicacaoInterna: {
    name: "Soluções --> Exibir campo Comunicação Interna ao criar/editar",
    type: "termoReferencia",
    description: [
      `Libera o campo 'Comunicação Interna (CI)' no cadastro/ediçãode uma solução na aba 'Termos de Referência -> Soluções' do município`,
    ],
  },
  exibeContrato: {
    name: "Libera o campo de contrato em Soluções ",
    type: "termoReferencia",
    description: [`Libera o campo de contrato em Soluções`],
  },
  exibeDetalhesSolucao: {
    name: "Solução --> Libera a exibição dos campos de Tarefas/visita e horas ",
    type: "termoReferencia",
    description: [
      `Libera o campo Tarefas/visita`,
      `Libera o campo MÁXIMO DE HORAS`,
      `Libera o campo Não computa horas?`,
    ],
  },
  exibirFiltro: {
    name: "Mostrar ou esconder o filtro",
    type: "listaMunicipio",
    description: [
      `Libera a possibilidade de visualizar o filtro da tela de listagem de município`,
    ],
  },
  exibirPfAtendida: {
    name: "Visualizar Empresas Atendidas",
    type: "relatorio",
    description: [
      `Libera o campo 'Pessoas Físicas Atendidas' no cadastro/edição na aba 'Relatório' do município`,
    ],
  },
  exibirPjAtendida: {
    name: "Visualizar Pessoas Físicas Atendidas",
    type: "relatorio",
    description: [
      `Libera o campo 'Empresas Atendida' no cadastro/edição na aba 'Relatório' do município`,
    ],
  },
  exibirSecretaria: {
    name: "Editar Município --> Exibir secretaria do municipio",
    type: "cidade",
    description: [
      `Libera a possibilidade de criar secretarias na edição do município`,
      `Possibilita visualizar a opção de escolher secretarias para uma solução`,
    ],
  },
  finalizarAcompanhamento: {
    isButton: true,
    name: "Finalizar Acompanhamento",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Finalizar' dentro de Cidade -> Acompanhamento -> Escolha o acompanhamento`,
    ],
  },
  gerarEditarProposta: {
    name: "Proposta --> Gerar nova proposta e editar propostas",
    type: "cidade",
    description: [`Gerar e editar uma proposta`],
  },
  grupo: {
    name: "Grupos",
    type: "menu",
    description: [`Libera a visualização do menu 'Grupos'`],
  },
  grupos: {
    name: "Grupos",
    type: "cidade",
    description: [`Libera a visualização da aba 'Grupos' dentro do município`],
  },
  incluirObsevacoes: {
    name: "Incluir Observações no relatório geral",
    type: "dashboard",
    description: [`Libera a opção de 'Incluir Observações' no relatório geral`],
  },
  liberarMaximoEixoMA: {
    name: "Proposta --> Adicionar mais de 5 eixos em uma proposta MA",
    type: "cidade",
    description: [`Consegue adicionar mais de 5 eixos em uma proposta MA `],
  },
  medalhas: {
    name: "Medalhas",
    type: "menu",
    description: [`Libera a visualização do menu 'Medalhas'`],
  },
  menuGestaoTerritorios: {
    name: "Liberar menu Gestão de Territórios",
    type: "menu",
    description: [`Liberar menu Gestão de Territórios`],
  },
  meusProcessosPagamentos: {
    name: "Meus Processos de Pagamentos",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Meus Processos de Pagamentos'`,
    ],
  },
  municipiosNaoVigentesRespondemPerguntasNacionais: {
    name: "Municípios não vigentes respondem só perguntas nacionais?",
    type: "sistema",
    description: [
      `Filtra as perguntas para somente nacionais na tela de acompanhamento e diagnóstico`,
    ],
  },
  naoVerClienteOcultoOuro: {
    name: "Não ver Cliente Oculto em cidades Ouro",
    type: "cidade",
    description: [
      `Libera a visualização da aba de cliente oculto somente para cidades que não sejam ouro`,
    ],
  },
  novoAcompanhamento: {
    isButton: true,
    name: "Novo Acompanhamento",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Novo Acompanhamento' dentro de Cidade -> Acompanhamento`,
    ],
  },
  novoEvento: {
    isButton: true,
    name: "Novo Evento",
    type: "calendario",
    description: [
      `Libera a visualização do botão 'novoEvento' dentro de Cidade -> Calendário`,
    ],
  },
  novoGrupo: {
    isButton: true,
    name: "Novo Grupo",
    type: "grupo",
    description: [
      `Libera a visualização do botão '+ Grupo' dentro de Cidade -> Grupos`,
    ],
  },
  novoRelatorio: {
    isButton: true,
    name: "Novo Relatório",
    type: "relatorio",
    description: [
      `Libera a visualização do botão 'Novo Relatório' dentro de Cidade -> Relatórios`,
    ],
  },
  novoRelatorioAdministrativo: {
    isButton: true,
    name: "Novo Relatório Admin.",
    type: "relatorioAdmin",
    description: [
      `Libera a visualização do botão 'Novo Relatório Administrativo' dentro de Cidade -> Relatório Administrativo`,
    ],
  },
  ocultarRelatorioAdministrativos: {
    name: "Processo de Pagamento --> Ocultar relatórios administrativos",
    type: "menu",
    description: [
      `Oculta o relatório administrativo no processo de pagamanento nas telas de criação e aprovação`,
    ],
  },
  pacotes: {
    name: "Pacotes",
    type: "menu",
    description: [`Libera a visualização do menu 'Pacotes'`],
  },
  permiteAddMunicipiosInstituicao: {
    name: "Instituição --> Visualizar campo municípios na instituição",
    type: "menu",
    description: [`Libera o campos município na instituição`],
  },
  permiteDeletarInstituicao: {
    name: "Instituição --> Deletar",
    type: "menu",
    isButton: true,
    description: [`Libera a deleção no menu Instituição`],
  },
  permiteEditarInstituicao: {
    name: "Instituição --> Editar",
    type: "menu",
    isButton: true,
    description: [`Libera a edição no menu Instituição`],
  },
  podeAnalisarProposta: {
    name: "Proposta --> Pode analisar proposta",
    type: "cidade",
    description: [`Aprovar ou rejeitar uma proposta`],
  },
  podeAnalisarRelatorio: {
    name: "Analisar Relatório --> Pode analisar relatórios",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar o filtro por Grupo de Solução do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar o filtro por Responsável do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar o motivo da rejeição caso o status do relatorio seja igual a reprovado do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de excluir um relatório do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de analisar um relatório ao clicar sobre ele do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de finalziar uma solução do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar todos os relatórios do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de Aprovar ou Rejeitar um relatório do menu 'Analisar Relatórios'`,
      `Libera a possibilidade de visualizar todos os relatórios dentro da aba 'Relatórios' no município`,
    ],
  },
  podeAnalisarRelatorioAdmin: {
    name: "Analisar Relatório Admin --> Pode analisar relatórios admin",
    type: "menu",
    description: [
      `Libera a visualização do menu 'Analisar/Meus Relatórios Administrativos'`,
      `Libera a possibilidade de visualizar o filtro por Responsável do menu 'Analisar Relatórios Adminsitrativos'`,
      `Libera a possibilidade de excluir um relatório admin. do menu 'Analisar Relatórios Adminsitrativos'`,
      `Libera a possibilidade de avaliar um relatório admin. do menu 'Analisar Relatórios Adminsitrativos'`,
      `Libera a possibilidade de visualizar todos os relatórios admin. do menu 'Analisar Relatórios Adminsitrativos'`,
    ],
  },
  podeCriarEvensoSemTarefaCalendario: {
    name: "Pode criar evento sem Tarefa",
    type: "cidade",
    description: [
      `Libera a possibilidade de criar um evento sem a necessidade de uma tarefa`,
    ],
  },
  podeCriarTarefaApenasSemComboCalendario: {
    name: "Criar tarefa APENAS quando não existir disponíveis na combo",
    type: "calendario",
    description: [
      `Libera a possibilidade de criar tarefas na criação de um evento no calendário do município, somente quando não existir tarefas disponíveis na combo`,
    ],
  },
  podeCriarTarefaNoCalendario: {
    name: "Criar tarefa",
    type: "calendario",
    description: [
      `Libera a possibilidade de criar tarefas na criação de um evento no calendário do município`,
    ],
  },
  podeExcluirEncontro: {
    name: "Encontros --> Pode Excluir Encontros",
    type: "menu",
    description: [
      `Libera a possibilidade de excluir encontros no menu 'Encontros'`,
    ],
  },
  podeExcluirProposta: {
    name: "Proposta --> Pode excluir proposta",
    type: "cidade",
    description: [`Excluir uma proposta`],
  },
  podeExcluirRelatorio: {
    name: "Meus Relatórios --> Pode Excluir Relatórios",
    type: "menu",
    description: [
      `Libera a possibilidade de excluir relatórios no menu 'Analisar/Meus Relatórios'`,
    ],
  },
  podeFinalizarClienteOculto: {
    name: "Cliente Oculto --> Pode Finalizar Cliente Oculto",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Finalizar' na aba 'Cliente Oculto' no município`,
    ],
  },
  podeRetirarSolucaoPropostaPacote: {
    name: "Proposta --> Em MT pode retirar uma solução do pacote ma proposta",
    type: "solucoes",
    isButton: true,
    description: [
      `Somente para MT, libera do usuário pode excluir soluções que sejam do pacote na proposta`,
    ],
  },
  podeSelecionarMaisDeUmUsuarioSolucao: {
    name: "Solução --> Pode selecionar mais de um responsável por solução",
    type: "termoReferencia",
    description: [
      `Libera a possibilidade de adicionar mais de um responsável na edição/criação de soluções na aba de "Termos de Referência -> Soluções" do município`,
    ],
  },
  podeTrocarLinkRelFim: {
    name: "Relatório Final --> Editar Link Cliente Oculto",
    type: "cidade",
    description: [
      `Libera a possibilidade de trocar o link do cliente oculto no relatório final`,
    ],
  },
  processosPagamentos: {
    name: "Processos de Pagamento",
    type: "menu",
    description: [`Libera a visualização do menu 'Processos de Pagamento'`],
  },
  projetoseSolucoes: {
    name: "Projetos e Soluções",
    type: "menu",
    description: [`Libera a visualização do menu 'Projetos e Soluções'`],
  },
  realizarDiagnostico: {
    name: "Realizar Diagnóstico",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'RESPONDER CRITÉRIOS DE AVALIAÇÃO/RESPONDER DIAGNÓSTICO' dentro do município, caso o diagnóstico não tenha sido respondido ainda.`,
    ],
  },
  reabrirCliente: {
    name: "Cliente Oculto --> Reabrir Cliente Oculto",
    type: "cidade",
    isButton: true,
    description: [
      `Libera a visualização do botão 'Reabrir Cliente Oculto' na aba 'Cliente Oculto' no município`,
    ],
  },
  relatorioAdministrativo: {
    name: "Relatório Administrativo",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Relatório Administrativo' dentro do município`,
      `Libera a visualização da opção 'Incluir Relatórios Administrativos' dentro do Relatório Global`,
    ],
  },
  relatorioGeral: {
    name: "Relatório Geral",
    type: "dashboard",
    isButton: true,
    description: [`Libera o botão para o relatório geral no menu 'Dashboard'`],
  },
  relatorioGlobal: {
    isButton: true,
    name: "Relatório Global",
    type: "dashboard",
    description: [
      `Libera a visualização do botão 'Relatório Global' dentro do menu Dashboard`,
    ],
  },
  relatorioMensal: {
    isButton: true,
    name: "Relatório Mensal",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Relatório Mensal' dentro do município`,
    ],
  },
  relatorios: {
    name: "Relatórios",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Relatório' dentro do município`,
    ],
  },
  resumoMunicipio: {
    isButton: true,
    name: "Atores do Município",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'RESUMO DO PARCEIRO/Municipio | Atores do município' dentro do município`,
    ],
  },
  respondePerguntaEixoMunicipio: {
    name: "Editar Município --> Responde pergunta sobre eixos escolhidos",
    type: "cidade",
    description: [
      `Libera a visualização da pergunta 'No ano corrente o município recebeu ações do eixo?' dentro da edição do município`,
    ],
  },
  sala: {
    name: "Sala",
    type: "cidade",
    description: [`Libera a visualização da aba 'Sala' dentro do município`],
  },
  salaEmpreendedor: {
    name: "Sala do Empreendedor",
    type: "menu",
    description: [`Libera a visualização do menu 'Sala do Empreendedor'`],
  },
  salvarMunicipio: {
    isButton: true,
    name: "Editar Municipio --> Salvar",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Salvar' municipios não vigentes dentro da edição de município`,
    ],
  },
  salvarMunicipioVigente: {
    isButton: true,
    name: "Editar Municipio --> Salvar (Municipios Vigente)",
    type: "cidade",
    description: [
      `Libera a visualização do botão 'Salvar' municipios vigentes dentro da edição de município`,
    ],
  },
  solucoes: {
    name: "Soluções",
    type: "menu",
    description: [`Libera a visualização do menu 'Soluções'`],
  },
  tarefaRealizada: {
    name: "Pode Gerar Tarefa Recorrente",
    type: "calendario",
    description: [`Pode gerar uma tarefa recorrente`],
  },
  temas: {
    name: "Temas",
    type: "menu",
    description: [`Libera a visualização do menu 'Temas'`],
  },
  termoReferencia: {
    name: "Termo de Referência",
    type: "cidade",
    description: [
      `Libera a visualização da aba 'Termos de Referência' dentro do município`,
    ],
  },
  termRefAddEvidencia: {
    name: "Adicionar Evidência",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de adicionar evidência na aba de 'Termos de Referência'`,
    ],
  },
  termRefAddGrupoSolucao: {
    name: "Adicionar Grupo de Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de adicionar grupo de solução na aba de 'Termos de Referência'`,
    ],
  },
  termRefAddSolucao: {
    name: "Adicionar Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de adicionar solução na aba de 'Termos de Referência'`,
    ],
  },
  termRefAddTarefa: {
    name: "Adicionar Tarefa",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de adicionar tarefa na aba de 'Termos de Referência'`,
    ],
  },
  termRefEditarEvidencia: {
    name: "Editar Evidência",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de editar evidência na aba de 'Termos de Referência'`,
    ],
  },
  termRefEditarGrupoSolucao: {
    name: "Editar Grupo de Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de editar grupo de solução na aba de 'Termos de Referência'`,
    ],
  },
  termRefEditarSolucao: {
    name: "Editar Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de editar solução na aba de 'Termos de Referência'`,
    ],
  },
  termRefEditarTarefa: {
    name: "Editar Tarefa",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de editar tarefa na aba de 'Termos de Referência'`,
    ],
  },
  termRefExcluirEvidencia: {
    name: "Excluir Evidência",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de excluir evidência na aba de 'Termos de Referência'`,
    ],
  },
  termRefExcluirGrupoSolucao: {
    name: "Excluir Grupo de Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de excluir grupo de solução na aba de 'Termos de Referência'`,
    ],
  },
  termRefExcluirSolucao: {
    name: "Excluir Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de excluir solução na aba de 'Termos de Referência'`,
    ],
  },
  termRefExcluirTarefa: {
    name: "Excluir Tarefa",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de excluir tarefa na aba de 'Termos de Referência'`,
    ],
  },
  termRefImportarGrupoSolucao: {
    name: "Importar Grupo de Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de importar grupo de solução na aba de 'Termos de Referência'`,
    ],
  },
  termRefImportarSolucao: {
    name: "Importar Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de importar solução na aba de 'Termos de Referência'`,
    ],
  },
  termRefImportarTarefa: {
    name: "Importar Tarefa",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de importar tarefa na aba de 'Termos de Referência'`,
    ],
  },
  termRefInterromperSolucao: {
    name: "Interromper Solução",
    type: "termoReferencia",
    isButton: true,
    description: [
      `Libera o botão de interromper solução na aba de 'Termos de Referência'`,
    ],
  },
  umTarefaValorRelatorio: {
    name: "Salvar uma tarefa com valor de relatório",
    type: "relatorio",
    description: [
      `Vamos considerar que caso tenha apenas uma tarefa no relatório, ela seja contabilizada pelas horas do relatório e não por sua hora normal`,
    ],
  },
  unidadesRegionais: {
    name: "Unidades Regionais",
    type: "menu",
    description: [`Libera a visualização do menu 'Unidades Regionais'`],
  },
  usuario: {
    name: "Usuarios",
    type: "menu",
    description: [`Libera a visualização do menu 'Usuarios'`],
  },
  usuarios: {
    name: "Usuarios",
    type: "menu",
    description: [`Libera a visualização do menu 'Usuarios'`],
  },
  verBotaoPropostaIniciarExecucao: {
    name: "Proposta --> Pode Iniciar Execução",
    type: "city",
    isButton: true,
    description: [`Libera o botão de Iniciar Execução da proposta`],
  },
  verCampoInstituicaoMembro: {
    name: "Membros --> Ver campo Instituição",
    type: "cidade",
    description: [`Libera a combo Instituição dentro de membros`],
  },
  verClienteOculto: {
    name: "Ver Cliente Oculto",
    type: "cidade",
    description: [
      `Libera a possibilidade de visualização da aba 'Cliente Oculto' no município`,
    ],
  },
  verContrato: {
    name: "Libera o campo de contrato em Rel Admin ",
    type: "relatorioAdmin",
    description: [`Libera o campo de contrato em Eelatório admin`],
  },
  verCustoPreco: {
    name: "Ver opção de custo e preço",
    type: "solucoes",
    description: [
      `Libera o campo 'Custo' e 'Preço' no cadastro/edição de uma solução em 'Termos de Referências - > Soluções'`,
      `Libera o campo 'Custo' e 'Preço' no cadastro/edição de uma solução no menu 'Projetos e Soluções -> Soluções`,
    ],
  },
  verDashboardEvidencia: {
    name: "Mini Dashboard Evidências",
    type: "cidade",
    description: [
      `Libera a possibilidade de visualizar o mini dashboard de evidências do selo no município`,
    ],
  },
  verDataContratoSolucao: {
    name: "Soluções --> Libera campos Inicio e Fim do contrato",
    type: "termoReferencia",
    description: [
      `Libera o campo Início e Fim do contrato dentro da aba de soluções em termo de referência`,
    ],
  },
  verDownloadPdfAcompanhamento: {
    name: "Acompanhamento --> Download PDF",
    type: "cidade",
    isButton: true,
    description: [
      `Libera o download do PDF do acompanhamento na aba de 'Acompanhamentos' do município`,
    ],
  },
  verDuracaoCalendario: {
    name: "Liberar duração do calendário",
    type: "calendario",
    description: [
      `Libera o campo duração do calendário na criação de um evento`,
    ],
  },
  verEducacaoEmpreendedora: {
    name: "Visualizar menu Educação Empreendedora ",
    type: "menu",
    isButton: true,
    description: [`Libera a visualização do menu Educação Empreendedora`],
  },
  verEvolucaoMunicipio: {
    name: "Visualiza Evolução do Município",
    type: "cidade",
    description: [
      `Libera a visualização da "EVOLUÇÃO DO MUNICÍPIO" e seus gráficos`,
    ],
  },
  verFaixaIdMunicipio: {
    name: "Editar Município --> Visualizar campo faixa",
    type: "cidade",
    description: [`Visualizar campo Faixa na edição do município`],
  },
  verMeusRelatorios: {
    name: "Meus Relatórios",
    type: "menu",
    description: [
      `Libera o menu 'Meus Relatórios', porém é necessário a liberação da permissão "Analisar Relatorios" para funcionar`,
    ],
  },
  verMenuMeusRelatoriosAdmin: {
    name: "Ver menu relatorios admin",
    type: "menu",
    description: [`Libera a visualização do menu 'Meus Relatórios Admin'`],
  },
  verMenuCategorias: {
    name: "Categorias",
    type: "menu",
    description: [`Libera a visualização do menu Categorias`],
  },
  verMenuContrato: {
    name: "Ver menu contratos",
    type: "menu",
    description: [`Libera a possibilidade de ver o menu de contratos.`],
  },
  verMenuFaixas: {
    name: "Faixa",
    type: "menu",
    description: [`Visualizar o menu faixa`],
  },
  verMenuInstituicao: {
    name: "Instituição",
    type: "menu",
    description: [`Libera a visualização do menu Instituição`],
  },
  verMenuMunicipioEixos: {
    name: "Visualizar menu Municípios Eixos ",
    type: "menu",
    isButton: true,
    description: [`Libera a visualização do menu do municipio eixo`],
  },
  verMenuMunicipioTemas: {
    name: "Município Temas",
    type: "menu",
    description: [`Libera a visualização do menu Município Temas`],
  },
  verMenuProposta: {
    name: " Visualizar proposta ",
    type: "cidade",
    description: [`Libera a aba de proposta na cidade`],
  },
  verParcialAcaoFinalizada: {
    name: "Editar Encontro --> Visualizar Parcial e Ação Finalizada",
    type: "calendario",
    description: [
      `Libera a possibilidade de visualizar e editar a opção de 'Parcial' ou 'Ação Finalizada' na criação/edição do evento no calendário do município`,
      `Libera a possibilidade de visualizar o "Tipo de Encontro/Agenda" na criação de um relátorio no município`,
      `Libera a possibilidade de visualizar a opção de "Apenas relatórios de Ações finalizadas" dentro do relatório global`,
    ],
  },
  verPontosAcoesAcompanhamento: {
    name: "Acompanhamento --> Visualizar Pontos e Plano de Ação ",
    type: "city",
    isButton: true,
    description: [
      `Libera a visualização dos pontos e plano de ação na listagem de acompanhamentos`,
    ],
  },
  verPontosObtidos: {
    name: "Ver Pontos Obtidos",
    type: "cidade",
    description: [
      `Libera a visualização de 'Pontos Obtidos' no mini dash de evidências`,
    ],
  },
  verPortifolioSolucao: {
    name: "Soluções --> Libera campo Portifólio",
    type: "termoReferencia",
    description: [
      `Libera o campo Portifólio dentro da aba de soluções em termo de referência`,
    ],
  },
  verProjetoPrateleira: {
    name: "Projetos e Solução --> Ver aba projeto",
    type: "menu",
    description: [`Ver a aba projeto dentro do menu de projetos e solução`],
  },
  verRelacaoCEMunEixo: {
    name: "Municípios Eixos --> Mostrar Check Relação com CE",
    type: "menu",
    description: [
      `Libera a visualização do checkbox 'Relação com CE' na tela de municípios eixos`,
    ],
  },
  verSolucoesExtras: {
    name: "Proposta --> Soluções Extra ",
    type: "solucoes",
    isButton: true,
    description: [
      `Libera a possibilidade de criação de soluções extras na proposta.`,
    ],
  },

  liberarCarenciaPropostaMaDataVencimentoParcela: {
    name: "Proposta --> MA --> Liberar carência da data de vencimento da parcela",
    type: "cidade",
    description: [
      `Libera a possibilidade de passar a carência da data de vencimento da parcela na proposta`,
    ],
  },
  podeReenviarEmailProcessoPagamento: {
    name: "Pode Reenviar Email",
    type: "processoPagamento",
    description: [`Pode Reenviar email`],
  },
  // verStatusDiagnosticoSelo: {
  //   name: "Ver status da fase do diagnóstico",
  //   type: "cidade",
  //   description: [
  //     `Libera a possibilidade de visualizar a fase do diagnóstico do selo, necessário a liberação da permissão do 'Diagnostico do Selo'`,
  //   ],
  // },
  verStatusSolucao: {
    name: "Soluções --> Libera campo status contrato",
    type: "termoReferencia",
    description: [
      `Libera o campo Status dentro da aba de soluções em termo de referência`,
    ],
  },
  verTipoSolucao: {
    name: "Soluções --> Exibir campo Tipo de solução.",
    type: "termoReferencia",
    description: [
      `Libera a opção de visualização e edição do campo 'Tipo de solução' na aba 'Termos de Referência -> Soluções' do município`,
      `Libera a opção de visualização e edição do campo 'Tipo de solução' no menu 'Projetos e Soluções -> Soluções'`,
    ],
  },
  verTodosMembrosMunicipio: {
    name: "Grupo --> Membros --> Editar/Cadastrar ver todos os membros",
    type: "cidade",
    description: [
      `Ver todos os membros de todos os municipios na hora de inserir um membro`,
    ],
  },
  visualizarAprovadas: {
    isButton: true,
    name: "Visualizar Aprovadas",
    type: "evidencia",
    description: [
      `Libera a visualização dos arquivos na tela de Aprovadas em Cidade -> Evidências`,
    ],
  },
  visualizarEvidenciadas: {
    isButton: true,
    name: "Visualizar Evidenciadas",
    type: "evidencia",
    description: [
      `Libera a visualização dos arquivos na tela de Evidenciadas em Cidade -> Evidências`,
    ],
  },
  visualizarIniciativaTerritorio: {
    name: "Visualizar Iniciativa Território",
    type: "territorios",
    description: [
      `Libera a possibilidade de visualizar iniciativas em um território`,
    ],
  },
  visualizarLogo: {
    name: "Visualizar Logo no Sistema",
    type: "sistema",
    description: [
      `Libera a visualização da logo do sistema em páginas e relatórios`,
    ],
  },
  visualizarPontosMedalha: {
    name: "Visualizar Pontos e Medalhas",
    type: "sistema",
    description: [`Libera a visualização dos pontos e medalhas do sistema`],
  },
  visualizarRejeitadas: {
    isButton: true,
    name: "Visualizar Rejeitadas",
    type: "evidencia",
    description: [
      `Libera a visualização dos arquivos na tela de Rejeitadas em Cidade -> Evidências`,
    ],
  },
  visualizarTerritorio: {
    name: "Visualizar Território",
    type: "territorios",
    description: [`Libera a possibilidade de visualizar um território`],
  },
  visualizarUsuarioDesabilitado: {
    name: "Visualizar listagem de usuário desabilitados",
    type: "usuario",
    description: [
      `Libera a visualização da lista de usuários desabilitados no menu de usuários`,
    ],
  },
  visualizaRelatorioFinal: {
    name: "Relatório Final",
    type: "cidade",
    description: [
      `Libera a visualização do botão "Relatório Final" dentro do município`,
    ],
  },
  visualizaTarefasExecutadas: {
    name: "Visualizar tarefas já executadas",
    type: "calendario",
    description: [
      `Libera a possibilidade de visualizar tarefas já executadas nas opções de tarefas de criação/edição de um evento no calendário do município`,
    ],
  },
  visualizaTodosEncontros: {
    name: "Encontros --> Pode Visualizar todos os encontros",
    type: "menu",
    description: [
      `Libera a visualização de todos os encontros dentro do Menu -> Encontros`,
    ],
  },
  visualizaEixosIds: {
    name: "Visualizar Eixos Ids",
    type: "cidade",
    description: [
      `Libera a visualização dos ids dos eixos na edição do município`,
    ],
  },

  enviaPerguntaId1Selo: {
    name: "Pode enviar dados no Plano de Ação do Selo ",
    type: "evidencia",
    description: [
      `Libera o envio de dados no Plano de Ação do Selo, o que equivale ao pergunta 1`,
    ],
  },
  verMenuMunicipiosAds: {
    name: "Pode ver o menu do Municípios Ads",
    type: "menu",
    description: [`Libera a visualização do menu 'Municípios Ads'`],
  },
  editarMunicipiosAds: {
    name: "Pode editar agentes no Municípios Ads",
    type: "municipioAds",
    description: [
      `Necessário permissão 'Pode ver o menu do Municípios Ads'`,
      `Permite editar agentes no menu municípios ads`,
      ,
    ],
  },
  excluirMunicipiosAds: {
    name: "Pode excluir agentes no Municípios Ads",
    type: "municipioAds",
    description: [
      `Necessário permissão 'Pode ver o menu do Municípios Ads'`,
      `Permite excluir agentes no menu municípios ads`,
      ,
    ],
  },
  cadastrarMunicipiosAds: {
    name: "Pode cadastrar agentes no Municípios Ads",
    type: "municipioAds",
    description: [
      `Necessário permissão 'Pode ver o menu do Municípios Ads'`,
      `Permite cadastrar agentes no menu municípios ads`,
      ,
    ],
  },
  visualizarMunicipiosAds: {
    name: "Pode visualizar agentes no Municípios Ads",
    type: "municipioAds",
    description: [
      `Necessário permissão 'Pode ver o menu do Municípios Ads'`,
      `Permite visualizar agentes no menu municípios ads`,
      ,
    ],
  },
  verTipoEncontro: {
    name: "Liberar Tipo de Encontro",
    type: "calendario",
    description: [`Libera a visualização do tipo de encontro no calendário`],
  },
  relatorioHorasRemotasHorasPresenciais: {
    name: "Mostrar horas remotas e presenciais",
    type: "relatorio",
    description: [
      `Libera a visualização das horas remotas e presenciais no relatório`,
    ],
  },
  verTipoSolucaoProcessoPagamento: {
    name: "Processo de Pagamento --> Ver Tipo",
    type: "processoPagamento",
    description: [`Libera a visualização do tipo no processo de pagamento`],
  },
  verSomenteRegional: {
    name: "Editar --> Ver somente Projeto, Imagem, IBGE, Nome e Unidade Regional",
    type: "cidade",
    description: [
      `Libera a visualização do projeto, da imagem, do código ibge, do nome do municipio e da unidade regional na listagem de municípios`,
      `O código e o nome são visiveis mas não editáveis`,
    ],
  },
  podeExcluirRelatorioAprovado: {
    name: "Pode Excluir Relatório Aprovado",
    type: "relatorio",
    description: [
      `Libera a exclusão de relatórios aprovados ao analisar relatórios`,
    ],
  },
};

const headerTypes = {
  calendario: "Municipio --> Cidade --> Calendário -->",
  cidade: "Municipio --> Cidade -->",
  dashboard: "Menu --> Dashboard Admin. -->",
  evidencia: "Municipio --> Cidade --> Evidência -->",
  grupo: "Municipio -- > Cidade-- > Grupos -->",
  menu: "Menu -->",
  relatorio: "Municipio -- > Cidade --> Relatório -->",
  relatorioAdmin: "Municipio -- > Cidade --> Relatório Admin.-->",
  solucoes: "Soluções -->",
  sistema: "Sistema -->",
  territorios: "Gestão de Territórios -->",
  termoReferencia: "Municipio -- > Cidade --> Termo Referen.-->",
  listaMunicipio: "Lista de Municípios -->",
  usuario: "Usuário -->",
  municipioAds: "Menu --> Municipio Ads -->",
  processoPagamento: "Menu --> Processo de Pagamento -->",
};

export const initialConfig = {
  acompanhamentos: false,
  adicionarCategoriaTerritorio: false,
  adicionarIniciativaTerritorio: false,
  adicionarTerritorio: false,
  agenteTerritorial: false,
  analisarAprovadas: false,
  analisarEvidenciadas: false,
  analisarRejeitadas: false,
  analisarRelatorios: false,
  analisarRelatoriosAdministrativos: false,
  andamento: false,
  cadastroEmLote: false,
  calendario: false,
  carregaMembrosGrupos: true,
  configuracao: false,
  dashboardAdministrativo: false,
  desabilitarUsuario: false,
  diagnosticoSelo: false,
  downloadDiagnostico: false,
  editarCategoriaTerritorio: false,
  editarIniciativaTerritorio: false,
  editarMunicipio: false,
  editarMunicipioVerAD: false,
  editarMunicipioVerAtividadeEconomica: false,
  editarMunicipioVerDadosSocioeconomicos: false,
  editarMunicipioVerEixos: false,
  editarMunicipioVerPrefeito: false,
  editarTerritorio: false,
  editarTipoSolucao: false,
  editaHorasUtilizadas: false,
  editaHorasUtilizadasQuandoTarefasSemHrPredefinidas: false,
  eixos: false,
  encontros: false,
  enviarAprovadas: false,
  enviarEvidenciadas: false,
  enviarRejeitadas: false,
  enviarRespondidas: false,
  eventos: false,
  evidencias: false,
  recursos: false,
  criarRecursos: false,
  analisarRecursos: false,
  excluirTerritorio: false,
  exibeComunicacaoInterna: false,
  exibeContrato: false,
  exibeDetalhesSolucao: false,
  exibirFiltro: true,
  exibirPfAtendida: false,
  exibirPjAtendida: false,
  exibirSecretaria: false,
  finalizarAcompanhamento: false,
  gerarEditarProposta: false,
  grupo: false,
  grupos: false,
  incluirObsevacoes: false,
  liberarMaximoEixoMA: false,
  medalhas: false,
  menuGestaoTerritorios: false,
  meusProcessosPagamentos: false,
  municipiosNaoVigentesRespondemPerguntasNacionais: false,
  naoVerClienteOcultoOuro: true,
  novoAcompanhamento: false,
  novoEvento: false,
  novoGrupo: false,
  novoRelatorio: false,
  novoRelatorioAdministrativo: false,
  ocultarRelatorioAdministrativos: false,
  pacotes: false,
  permiteAddMunicipiosInstituicao: false,
  permiteDeletarInstituicao: false,
  permiteEditarInstituicao: false,
  podeAnalisarProposta: false,
  podeAnalisarRelatorio: false,
  podeAnalisarRelatorioAdmin: false,
  podeCriarEventoSemTarefaCalendario: true,
  podeCriarTarefaApenasSemComboCalendario: false,
  podeCriarTarefaNoCalendario: false,
  podeExcluirEncontro: false,
  podeExcluirProposta: false,
  podeExcluirRelatorio: false,
  podeFinalizarClienteOculto: false,
  podeRetirarSolucaoPropostaPacote: false,
  podeSelecionarMaisDeUmUsuarioSolucao: false,
  podeTrocarLinkRelFim: false,
  processosPagamentos: false,
  projetoseSolucoes: false,
  realizarDiagnostico: false,
  reabrirCliente: false,
  relatorioAdministrativo: false,
  relatorioGeral: false,
  relatorioGlobal: false,
  relatorioMensal: false,
  relatorios: false,
  reverterProposta: false,
  resumoMunicipio: false,
  respondePerguntaEixoMunicipio: false,
  sala: false,
  salaEmpreendedor: false,
  salvarMunicipio: true,
  salvarMunicipioVigente: false,
  solucoes: false,
  tarefaRealizada: false,
  temas: false,
  termoReferencia: false,
  termRefAddEvidencia: true,
  termRefAddGrupoSolucao: true,
  termRefAddSolucao: true,
  termRefAddTarefa: true,
  termRefEditarEvidencia: true,
  termRefEditarGrupoSolucao: true,
  termRefEditarSolucao: true,
  termRefEditarTarefa: true,
  termRefExcluirEvidencia: true,
  termRefExcluirGrupoSolucao: true,
  termRefExcluirSolucao: true,
  termRefExcluirTarefa: true,
  termRefImportarGrupoSolucao: true,
  termRefImportarSolucao: true,
  termRefImportarTarefa: true,
  termRefInterromperSolucao: true,
  temas: false,
  unidadesRegionais: false,
  umTarefaValorRelatorio: false,
  usuarios: false,
  verBotaoPropostaIniciarExecucao: false,
  verCampoInstituicaoMembro: false,
  verClienteOculto: false,
  verContrato: false,
  verCustoPreco: false,
  verDataContratoSolucao: false,
  verDownloadPdfAcompanhamento: false,
  verDuracaoCalendario: true,
  verEducacaoEmpreendedora: false,
  verEvolucaoMunicipio: true,
  verFaixaIdMunicipio: false,
  verMeusRelatorios: true,
  verMenuMeusRelatoriosAdmin: false,
  verMenuCategorias: false,
  verMenuContrato: false,
  verMenuFaixas: false,
  verMenuInstituicao: false,
  verMenuMunicipioEixos: false,
  verMenuMunicipioTemas: false,
  verMenuProposta: false,
  verParcialAcaoFinalizada: false,
  verPontosAcoesAcompanhamento: false,
  verPontosObtidos: false,
  verPortifolioSolucao: false,
  verProjetoPrateleira: false,
  verRelacaoCEMunEixo: false,
  verSolucoesExtras: false,
  verSomenteRegional: false,
  verStatusDiagnosticoSelo: false,
  verStatusSolucao: false,
  verTipoSolucao: false,
  verTodosMembrosMunicipio: false,
  visualizarAprovadas: false,
  visualizarEvidenciadas: false,
  visualizarIniciativaTerritorio: false,
  visualizarLogo: true,
  visualizarPontosMedalha: true,
  visualizarRejeitadas: false,
  visualizarTerritorio: false,
  visualizarUsuarioDesabilitado: false,
  visualizaRelatorioFinal: false,
  visualizaTarefasExecutadas: false,
  visualizaTodosEncontros: false,
  visualizaEixosIds: "[]",
  enviaPerguntaId1Selo: false,
  verMenuMunicipiosAds: false,
  editarMunicipiosAds: false,
  excluirMunicipiosAds: false,
  cadastrarMunicipiosAds: false,
  visualizarMunicipiosAds: false,
  liberarCarenciaPropostaMaDataVencimentoParcela: false,
  podeReenviarEmailProcessoPagamento: true,
  perguntas: false,
  verTipoEncontro: false,
  relatorioHorasRemotasHorasPresenciais: true,
  verTipoSolucaoProcessoPagamento: false,
  podeExcluirRelatorioAprovado: false,
};
